<template>
  <div class="scientific-speaker-list-item" :class="{'is-vip': isVip}">
    <span>{{speakerName}}</span>
    <span v-if="speakerPositionAncCompany">{{' - '}}</span>
    <span v-if="speakerPositionAncCompany">{{speakerPositionAncCompany}}</span>
  </div>
</template>

<script>
import { fullName, positionAndCompany } from "@/shared/utils";

export default {
  name: "AgendaSessionSpeakerScientificListItem",

  props: {
    speaker: {
      type: Object,
      required: true,
    },

    isSearchResult: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    speakerName() {
      return fullName(this.speaker);
    },

    speakerPositionAncCompany() {
      return positionAndCompany(this.speaker);
    },

    isVip() {
      return this.speaker.vip;
    }
  }
};
</script>

<style scoped lang="scss">
.scientific-speaker-list-item {
  font-style: normal;
  font-size: 15px;
  line-height: 19px;
  color: #000000;
  font-weight: 400;

  &.is-vip {
    font-weight: 700;
   }
}

</style>
